export default {
    methods: {
        verifyLogin: function() {
            if (localStorage.getItem("COIN-AUTH") == null) {
                this.$message.error("尚未登录");
                this.$router.push({
                    path: '/Login'
                })
            }
        }
    },
    created: function() {
        //this.verifyLogin();
    }
}